import { EventEmitter, ChangeDetectorRef, Component, Injector, Input, OnInit, Output } from '@angular/core';
import { DynamicData, DynamicDateType } from '../../interfaces/dynamic-data-type.interface';

@Component({
    selector: 'lib-dynamic-view',
    templateUrl: 'dynamic-view.component.html',
    styleUrls: [
        './dynamic-view.css'
    ]
})

export class DynamicViewComponent implements OnInit {
    _value: string = '';

    get value() {
        return this._value;
    }

    set value(val) {
        this._value = val;
        this.valueChange.emit(val);
    }

    private _data: DynamicData = null;
    @Input() set data(val: DynamicData) {
        this._data = val;
        this.setValue(val);
    }

    get data() {
        return this._data;
    }

    @Input() previousMaxDays = 30;
    @Input() futureMaxDays = 30;

    @Input() locale: any;

    previous_dateType: DynamicDateType  = 'day';
    previous_days: number = 1;

    future_dateType: DynamicDateType = 'day'
    future_days = 1;

    present_first_dateType: DynamicDateType = 'month';
    present_last_dateType: DynamicDateType = 'month';

    @Output() valueChange = new EventEmitter();

    constructor(private injector: Injector, private cd: ChangeDetectorRef) { }

    ngOnInit() { }

    onListItemFormControlClick($event) {
        const lbl = $event.target.closest('label');
        if (lbl) {
            lbl.click();
        }
    }

    setValue(val: DynamicData) {
        if (val) {
            this.value = val.name;
            switch(this.value) {
                case 'present_day': // ä»å¤©
                case 'present_month': // æ¬æ
                case 'present_year':
                    break;
                case 'previou':
                    this.previous_dateType = val.dateType;
                    this.previous_days = val.count;
                    break;
                case 'future':
                    this.future_dateType = val.dateType;
                    this.future_days = val.count;
                    break;
                case 'present_first':
                    this.present_first_dateType = val.dateType;
                    break;
                case 'present_last':
                    this.present_last_dateType = val.dateType;
                    break; 
            }
            this.cd.detectChanges();
        }
    }

    getValue(): DynamicData {
        let val = null;
        if (this.value) {
            switch(this.value) {
                case 'present_day': // ä»å¤©
                    val = {dateType:'day', period:'present', count: null, isFirstDay: false, isLastDay: false};
                    break;
                case 'present_month': // æ¬æ
                    val = {dateType:'month', period:'present', count: null, isFirstDay: false, isLastDay: false};
                    break;
                case 'present_year':
                    val = {dateType:'year', period:'present', count: null, isFirstDay: false, isLastDay: false};
                    break;
                case 'previou':
                    val = { dateType: this.previous_dateType , period:'previous', count: this.previous_days, isFirstDay: false, isLastDay: false};
                    break;
                case 'future':
                    val = { dateType: this.future_dateType , period:'future', count: this.future_days, isFirstDay: false, isLastDay: false};
                    break;
                case 'present_first':
                    val = { dateType: this.present_first_dateType , period:'present', count: null, isFirstDay: true, isLastDay: false};
                    break;
                case 'present_last':
                    val = { dateType: this.present_last_dateType , period:'present', count: null, isFirstDay: false, isLastDay: true};
                    break;
            }

            if (val) {
                val.name = this.value;
            }
        }
        return val;
    }

    private getDateTypeString(dt: DynamicDateType) {
        switch(dt) {
            case 'week':
                return this.locale.week || 'å¤©';
            case 'day':
                return this.locale.day || 'å¤©';
            case 'month':
                return this.locale.month || 'æ';
            case 'year':
                return this.locale.year || 'å¹´';
        }
    }

    formatValue() {
        const val = this.getValue();
        if (val) {
            let fval = '';
            switch(val.name) {
                case 'present_day': // ä»å¤©
                fval = this.locale.today || 'ä»å¤©';
                break;
            case 'present_month': // æ¬æ
                fval = this.locale.presentMonth || 'æ¬æ';
                break;
            case 'present_year':
                fval = this.locale.presentYear ||'æ¬å¹´';
                break;
            case 'previou':
                fval =  (this.locale.previous|| 'è¿å»') + ' ' + val.count + ' ' + this.getDateTypeString(val.dateType);
                break;
            case 'future':
                fval = (this.locale.future || 'æªæ¥') + ' '+ val.count + ' ' +this.getDateTypeString(val.dateType);
                break;
            case 'present_first':
                fval = (this.locale.current||'æ¬') + this.getDateTypeString(val.dateType) + (this.locale.first||'ç¬¬ 1 å¤©');
                break;
            case 'present_last':
                fval = (this.locale.current||'æ¬') + this.getDateTypeString(val.dateType) + (this.locale.last||'æå 1 å¤©');
                break;
            }

            return fval;
        } else {
            return '';
        }
    }


    private setDays(typ: string, days: number) {
        if (typ === 'previous') {
            this.previous_days = days;
        } else {
            this.future_days = days;
        }
    }

    checkMaxDays($event, tye: string) {
        const target = $event.target as any;
        const val = target.value.replace(/[^\d]/g,'');
        const days = Number(val);
        target.value = days;
        const max = tye === 'previous' ? this.previousMaxDays: this.futureMaxDays; 
        this.setDays(tye, days);

        if (days > max) {
            target.value = max;
            this.setDays(tye, max);
            return;
        } else {
            if (days < 1) {
                target.value = 1;
                this.setDays(tye, 1);
                return;
            }
        }
    }

    onNumberKeydown($event: KeyboardEvent) {
        $event.stopPropagation();
        if ($event.key === '.' || $event.key === '-' || $event.key === '+') {
            $event.preventDefault();
        }
    }
}